import { Button, makeStyles, Typography } from '@material-ui/core';
import PreviewContainer from '../../../Carousel/Preview';
import Card from '../../Card';
import { v4 } from 'uuid';
import useImageFallback from 'hooks/useImageFallback';
import { IInvite } from 'interface/invites';
import ThumbUp from '@material-ui/icons/ThumbUp';
import { useState } from 'react';
import MobileModal from './MobileModal';

const useStyles = makeStyles((theme) => ({
  loading: {
    animation: 'none !important',
    padding: theme.spacing(0, 6, 4, 0),
  },
  title: {
    marginTop: theme.spacing(2),
  },
  buttons: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4),
  },
  whiteButton: {
    background: theme.palette.grey[200],
    '&:hover': {
      background: theme.palette.grey[300],
    },
    '&:nth-of-type(2) svg': {
      transform: 'rotate(180deg)',
    },
    '& > span': {
      paddingRight: theme.spacing(1),
      textTransform: 'none',
      fontSize: 14,
      fontWeight: 600,
      color: theme.palette.grey[600],
      '& svg': {
        color: theme.palette.grey[600],
        width: '16px !important',
      },
    },
    '@media(min-width: 770px) and (max-width: 1440px)': {
      '& > svg': {
        width: '10px !important',
      },
      '& > span': {
        fontSize: 10,
      },
    },
  },
}));

interface Props extends IInvite {
  accept: () => Promise<any>;
  refuse: () => Promise<any>;
}

const InviteCard = ({ course, ...props }: Props) => {
  const [showDetails, setShowDetails] = useState(false);
  const classes = useStyles();
  const imageProps = useImageFallback(
    course.customization.new_avatar ?? course.customization.avatar,
    require(`assets/img/nutror-card-${course.id % 5}.png`)
  );

  const acceptInvite = () => {
    setShowDetails(false);
    props.accept();
  };

  const refuseInvite = () => {
    setShowDetails(false);
    props.refuse();
  };

  const toggleModal = () => {
    setShowDetails((isOpen) => !isOpen);
  };

  const defaultProps = {
    title: course.title,
    id: course.id,
    ...imageProps,
    style: { cursor: 'pointer' },
    onClick: () => {},
  };

  const uuid = v4();

  const renderButtons = (
    <div className={classes.buttons}>
      <Button startIcon={<ThumbUp />} variant='contained' className={classes.whiteButton} onClick={acceptInvite}>
        Aceitar
      </Button>
      <Button startIcon={<ThumbUp />} onClick={refuseInvite} variant='contained' className={classes.whiteButton}>
        Recusar
      </Button>
    </div>
  );

  return (
    <>
      <PreviewContainer.Iddle onTouch={toggleModal} id={uuid}>
        <Card {...defaultProps} />
      </PreviewContainer.Iddle>
      <PreviewContainer.Active id={uuid}>
        <Card {...defaultProps}>
          {renderButtons}
          <Typography className={classes.title} variant='body1' component='span'>
            {course.title}
          </Typography>
        </Card>
      </PreviewContainer.Active>
      <MobileModal open={showDetails} imageProps={imageProps} course={course} onClose={toggleModal}>
        {renderButtons}
      </MobileModal>
    </>
  );
};

export default InviteCard;
